import React, { useState, useEffect } from "react";

import RedHomePage from "../components/pages/home-page/red-home-page";
import RedInfoPage from "../components/pages/info-page/red-info-page";
import RedNavbarSection from "../components/navbar-section/red-navbar-section";
import RedStartSection from "../components/start-section/red-start-section";
import RedGyikPage from "../components/pages/gyik-page/red-gyik-page";
import RedMediaPage from "../components/pages/media-page/red-media-page";

import "./index.scss";

const RedPages = () => {
  const [startPageDissolve, setStartPageDissolve] = useState(false);
  const [startPageVisibility, setStartPageVisibility] = useState(false);
  const [timerValue, setTimerValue] = useState(false);

  const [youtubePlayer, setYoutubePlayer] = useState(false);
  const [nextPlaylist, setNextPlaylist] = useState(false);

  var horizontalScrolling = true;

  const setPlayerFunction = () => {
    setYoutubePlayer(!youtubePlayer);
  };

  const switchFunction = () => {
    setNextPlaylist(!nextPlaylist);
  };

  const mediaQuery = window.matchMedia("(max-width: 650px)");

  if (mediaQuery.matches) {
    horizontalScrolling = false;
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimerValue(!timerValue);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  const dissolve = () => {
    if (timerValue) {
      setStartPageDissolve(!startPageDissolve);
      setTimeout(() => {
        setStartPageVisibility(!startPageVisibility);
        setPlayerFunction();
      }, 2300);
    }
  };

  return (
    <div
      className={`pages ${startPageVisibility ? "active" : ""} ${
        horizontalScrolling ? "" : "horizontal-scrolling"
      }`}
    >
      <RedStartSection
        startPageDissolve={startPageDissolve}
        startPageVisibility={startPageVisibility}
        dissolve={dissolve}
      />

      {startPageDissolve && (
        <RedHomePage startPageVisibility={startPageVisibility} />
      )}
      {startPageDissolve && <RedInfoPage />}
      {startPageDissolve && <RedGyikPage />}
      {startPageDissolve && <RedMediaPage />}

      {startPageDissolve && (
        <RedNavbarSection
          setPlayerFunction={setPlayerFunction}
          youtubePlayer={youtubePlayer}
          switchFunction={switchFunction}
          horizontalScrolling={horizontalScrolling}
        />
      )}
    </div>
  );
};

export default RedPages;
